// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host, .container {
  position: absolute;
  top: 0;
  left: 0;
}

.index {
  z-index: 30 !important;
}

.pad-index {
  z-index: 115 !important;
}

.input-wrapper {
  display: block;
  overflow-y: auto;
}
.input-wrapper .input {
  border: none !important;
  overflow: hidden;
  display: inline;
  outline-width: 0px;
  word-wrap: none;
}
.input-wrapper .input.empty::before {
  content: "";
  position: absolute;
  top: 0;
  white-space: nowrap;
  opacity: 0.2;
}

.font-controls {
  padding: 5px;
  border: 1px solid black;
  border-radius: 20px;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  font-size: 20px;
  opacity: 0.6;
  box-sizing: border-box;
}
.font-controls.hidden {
  display: none;
}
.font-controls button {
  display: flex;
  flex-direction: row;
  font-size: 18px;
  min-width: 3vw;
  box-sizing: border-box;
  margin: 3px 0px;
  padding: 0;
  border-radius: 24px;
  padding: 6px;
  justify-content: center;
  align-items: center;
  background: lightgrey;
}

.dark-theme :host ::ng-deep .font-controls {
  background-color: gray;
}
.dark-theme :host ::ng-deep .input-wrapper::-webkit-scrollbar {
  width: 12px;
  border-radius: 10px;
  background-color: gray;
  opacity: 0.6;
}
.dark-theme :host ::ng-deep .input-wrapper::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-color: darkgrey;
  opacity: 0.6;
}`, "",{"version":3,"sources":["webpack://./src/activities/activity-header/text-box/text-box.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;AACF;;AAKA;EACE,sBAAA;AAFF;;AAIA;EACE,uBAAA;AADF;;AAGA;EACE,cAAA;EACA,gBAAA;AAAF;AACE;EACE,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,eAAA;AACJ;AAAI;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,mBAAA;EACA,YAAA;AAEN;;AAGA;EACE,YAAA;EACA,uBAAA;EACA,mBAAA;EAEA,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,eAAA;EACA,YAAA;EAEA,sBAAA;AAFF;AAIE;EACE,aAAA;AAFJ;AAKE;EACE,aAAA;EACA,mBAAA;EAED,eAAA;EACC,cAAA;EACA,sBAAA;EAEA,eAAA;EACA,UAAA;EACA,mBAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,qBAAA;AALJ;;AAWI;EACE,sBAAA;AARN;AAcM;EACE,WAAA;EACA,mBAAA;EACA,sBAAA;EACA,YAAA;AAZR;AAgBM;EACE,mBAAA;EACA,0BAAA;EACA,YAAA;AAdR","sourcesContent":[":host, .container {\n  position: absolute;\n  top: 0;\n  left: 0;\n  // height: 100%;\n  // width: 100%;\n  // z-index: 115;\n}\n\n.index {\n  z-index: 30 !important;\n}\n.pad-index {\n  z-index: 115 !important;\n}\n.input-wrapper {\n  display: block;\n  overflow-y: auto;\n  .input {\n    border: none !important;\n    overflow: hidden;\n    display: inline;\n    outline-width: 0px;\n    word-wrap: none;\n    &.empty::before {\n      content: \"\";\n      position:absolute;\n      top: 0;\n      white-space: nowrap;\n      opacity: .2;\n    }\n  }\n}\n\n.font-controls {\n  padding: 5px;\n  border: 1px solid black;\n  border-radius: 20px;\n  // width: 15vw;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-around;\n  font-size: 20px;\n  opacity: .6;\n\n  box-sizing: border-box;\n\n  &.hidden {\n    display: none;\n  }\n\n  button {\n    display: flex;\n    flex-direction: row;\n\n\t  font-size: 18px;\n    min-width: 3vw;\n    box-sizing: border-box;\n\n    margin: 3px 0px;\n    padding: 0;\n    border-radius: 24px;\n    padding: 6px;\n    justify-content: center;\n    align-items: center;\n    background: lightgrey;\n  }\n}\n\n:host ::ng-deep {\n  .font-controls {\n    .dark-theme & {\n      background-color: gray;\n    }\n  }\n\n  .input-wrapper {\n    &::-webkit-scrollbar {\n      .dark-theme & {\n        width: 12px;\n        border-radius: 10px;\n        background-color: gray;\n        opacity: 0.6;\n      }\n    }\n    &::-webkit-scrollbar-thumb {\n      .dark-theme & {\n        border-radius: 10px;\n        background-color: darkgrey;\n        opacity: 0.6;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
